export type SplitSpecs = Record<number, { aWidth: string; bWidth: string }>

export const DEFAULT_SPLIT_SPECS: SplitSpecs = {
    0: { aWidth: '40%', bWidth: '60%' },
    720: { aWidth: '35%', bWidth: '65%' },
    960: { aWidth: '30%', bWidth: '70%' },
    1280: { aWidth: '25%', bWidth: '75%' },
    1600: { aWidth: '20%', bWidth: '80%' },
}

type SplitOptions = {
    splitViewWidth?: number
    aMaxWidth?: number
    collapseA?: boolean
    favorA?: boolean
    favorB?: boolean
}

const resolveSpec = (width: number, specs: SplitSpecs) =>
    Object.entries(specs).reduce(
        (spec, [specWidth, values]) =>
            width > Number(specWidth) ? values : spec,
        { aWidth: '30%', bWidth: '70%' },
    )

const fraction = (percentage: string) => parseFloat(percentage) / 100

export const resolveSplit = (
    width: number,
    specs: SplitSpecs = DEFAULT_SPLIT_SPECS,
    {
        splitViewWidth = 600,
        aMaxWidth,
        collapseA = false,
        favorA = false,
        favorB = false,
    }: SplitOptions = {},
) => {
    const canFitBoth = splitViewWidth ? width > splitViewWidth : true
    const { aWidth, bWidth } = canFitBoth
        ? resolveSpec(width, specs)
        : { aWidth: '100%', bWidth: '100%' }
    const canDisplayA = !collapseA && (canFitBoth || !favorB)
    const canDisplayB = canFitBoth || !favorA
    const limitAWidth = canFitBoth && aMaxWidth !== undefined
    const aExpandedPixels = limitAWidth
        ? Math.min(width * fraction(aWidth), aMaxWidth)
        : width * fraction(aWidth)
    const bExpandedPixels = limitAWidth
        ? width - aExpandedPixels
        : width * fraction(bWidth)

    return {
        canFitBoth,
        canDisplayA,
        canDisplayB,
        limitAWidth,
        aWidth,
        bWidth,
        aExpandedPixels,
        bExpandedPixels,
        aPixels: canDisplayA ? aExpandedPixels : 0,
        bPixels: canDisplayA ? bExpandedPixels : width,
        originalBWidth: canDisplayA ? width * fraction(bWidth) : width,
    }
}
